import classnames from 'classnames';
import HllLoadingIcon from './hll-loading-icon';
import DefaultLoadingIcon from './default-loading-icon';
import './index.scss';

export interface LoadingProps {
  loading: boolean;
  className?: string;
  style?: React.CSSProperties;
  size?: 'small' | 'middle' | 'large' | 'huge';
  type?: 'hll' | 'default';
  /** 加载指示符 */
  indicator?: React.ReactNode;
  text?: string;
}

const Loading: React.FC<LoadingProps> = ({
  loading,
  className,
  style,
  size = 'middle',
  type = 'default',
  indicator,
  text,
  children
}) => {
  const getIcon = () => {
    if (indicator) {
      return indicator;
    }
    if (type === 'hll') {
      return <HllLoadingIcon size={size} />;
    }
    return <DefaultLoadingIcon size={size} />;
  };

  const loadingComponent = (
    <div className={classnames('csc-loading', `csc-loading-${size}`, className)} style={style}>
      {getIcon()}
      {text && <span className="csc-loading-text">{text}</span>}
    </div>
  );
  if (!children) {
    if (!loading) {
      return null;
    }
    return loadingComponent;
  }

  return (
    <div className="csc-loading-nested-container">
      {loading && <div className="csc-loading-nested-loading">{loadingComponent}</div>}
      <div
        className={classnames('csc-loading-nested-content', { 'csc-loading-nested-blur': loading })}
      >
        {children}
      </div>
    </div>
  );
};

export default Loading;
